var inputGroup;
var mainFormId;
var objectVal = [];

var metal = 2.25; //S металочерепици (ширина листа * на 2 метра) / превращяем в метры * нахлёст
var prof = 2.0;  //S профнастила (ширина листа * на 2 метра) / превращяем в метры * нахлёст

var coverType;

/**
 * @author felix
 * @package JS Calculator,
 */
window.wmCalculator = {

    build: function (type) {
        switch (type) {
            case '1':
                this.showForm(type);
                break;
            case '2':
                this.showForm(type);
                break;
            case '3':
                this.showForm(type);
                break;
            default:
                console.log('bad!' + type);
                break
        }
    },

    clearResult: function () {
        $('.sum-calc__b-table').empty();
        if (!$('.sub-calc__result').hasClass('hidden')) {
            $('.sub-calc__result').addClass('hidden');
        }

    },

    showForm: function (formId) {
        // work is test
        $('.calc-tab__item').hide();

        var currentTab = $('#tab-' + formId);
        currentTab.show();

        this.clearResult();

        // is not test
        this.clearForm();
        objectVal = [];
        // is not test END

        mainFormId = formId;
        inputGroup = currentTab;
    },

    mathFormul: function (typeId, object) {
        switch (typeId) {
            case '1':
                this.formulaOne(object);
                break;
            case '2':
                this.formulaTwo(object);
                break;
            case '3':
                this.formulaThree(object);
                break
        }
    },

    selectType: function (type) {
        if (typeof type === "undefined") {
            coverType = $('.calc__field input[name="cover"]').val();
            if (!coverType) {
                coverType = window.location.href.search('profnastil') === -1 ? '' : 'prof'
            }
        } else {
            coverType = type;
        }
    },

    clearForm: function () {
        $.each($('.calc__field input:text'), function () {
            $(this).val('');
        });

        this.clearError();
    },

    appendResult: function ($result, $key) {
        var $html = '<table class="sum-calc__table">';
        $html += '<thead><tr><th>Материалы кровли</th><th>Необходимое количество</th></tr></thead><tbody>';

        for (var key in $result) {
            if ($result[key]["separate"] === true) {
                //html += '<tr style="border-right:none;"><td style="border-left:none;background-color:#fff;padding-top: 10px;font-size: 10px;color: #505050;" colspan="2"><b>' + key + '</b></td></tr>';
            } else {
                $html += '<tr><td>' + key + '</td><td>' + $result[key][$key] + '</td></tr>';
            }
        }
        $html += '</tbody></table>';

        $('.sum-calc__b-table').empty().append($html);
        $('.sub-calc__result').removeClass('hidden');
    },

    showError: function (error) {

        $.each(error, function (index, element) {
            var calc__field = $('#tab-' + mainFormId + ' input[name=' + element + ']');

            $(calc__field).css('border', '1px solid red');
            var calc__field = $(calc__field).parent();

            var calc___field_desc = $(calc__field).find('.calc__field-desc:not(.calc__field-desc-error)');
            var call__desc_clone = calc___field_desc.hide().clone();
            call__desc_clone.addClass('calc__field-desc-error').text('Обязательно для заполнения');

            $(calc___field_desc).after(call__desc_clone);
            call__desc_clone.show();
        });
    },

    clearError: function () {
        $('.calc__field-input').removeAttr('style');
        $('.calc__field-desc-error').remove()
        $('.calc__field-desc').show();
    },

    /* 2-x скатная крыша */
    formulaOne: function (object) {
        var fields = ['a', 'b', 'c', 'd', 'e'];
        var error = [];

        this.clearError();

        for (var k in fields) {
            if (object[fields[k]] == undefined || object[fields[k]] == '') {
                error.push(fields[k]);
            }
        }

        if (error.length > 0) {
            // Error handling
            this.clearResult();

            this.showError(error)
        } else {
            var a = Number((object['a'].split(",")).join("."));
            var b = Number((object['b'].split(",")).join("."));
            var c = Number((object['c'].split(",")).join("."));
            var d = Number((object['d'].split(",")).join("."));
            var e = Number((object['e'].split(",")).join("."));

            var result = [];

            /* общая площадь */
            var S = (a + b) * c;

            if (coverType === 'prof') {
                result["Профнастил (2м.)"] = [];
                result["Профнастил (2м.)"]["sum"] = Math.ceil((S / prof) * 1.15) + ' шт';
            } else {
                result["Металлочерепица (2.25м.)"] = [];
                result["Металлочерепица (2.25м.)"]["sum"] = Math.ceil((S / metal) * 1.15) + ' шт';
            }

            result["Общая площадь кровли"] = [];
            result["Общая площадь кровли"]["sum"] = Math.ceil(S) + ' м2';

            result["Доборные элементы"] = [];
            result["Доборные элементы"]["separate"] = true;

            /* Формула "Конек и уплотнитель"*/
            result["Планка конька (2м.)"] = [];
            result["Планка конька (2м.)"]["sum"] = Math.ceil(c / (2 - 0.05)) + ' шт';
            result["Планка конька (2м.)"]["size"] = c.toFixed(2);
            /*end*/

            result["Уплотнитель планки конька (2м.)"] = [];
            result["Уплотнитель планки конька (2м.)"]["sum"] = Math.ceil(c / (2 - 0.05)) * 2 + ' шт';
            result["Уплотнитель планки конька (2м.)"]["size"] = c.toFixed(2);

            /* Формула расчёта "Ветровая (торцевая) планка" */
            var L = (a * 2) + (b * 2);

            result["Ветровая (торцевая) планка (2м.)"] = [];
            result["Ветровая (торцевая) планка (2м.)"]["sum"] = Math.ceil(L / (2 - 0.05)) + ' шт';
            result["Ветровая (торцевая) планка (2м.)"]["size"] = L;
            /*end*/

            /* Формула "Карнизная" */
            var n = c * 2;

            result["Карнизная планка (2м.)"] = [];
            result["Карнизная планка (2м.)"]["sum"] = Math.ceil(n / (2 - 0.05)) + ' шт';
            result["Карнизная планка (2м.)"]["size"] = n.toFixed(2);

            /*end*/

            /* "Примыкание нижняя"
             var o = 0.4*4;

             result["Планка примыкания (нижняя) (2м.)"] = [];
             result["Планка примыкания (нижняя) (2м.)"]["sum"] = Math.ceil(o/(2-0.05)) + ' шт';
             result["Планка примыкания (нижняя) (2м.)"]["size"] = o;
             */
            /*end*/

            /* "Примыкание верхняя"
             var p = 0.4*4;

             result["Планка примыкания (верхняя) (2м.)"] = [];
             result["Планка примыкания (верхняя) (2м.)"]["sum"] = Math.ceil(o/(2-0.05)) + ' шт';
             result["Планка примыкания (верхняя) (2м.)"]["size"] = p;
             */
            /*end*/

            result["Изоляционные материалы"] = [];
            result["Изоляционные материалы"]["separate"] = true;

            result["Гидроизоляция (75м2)"] = [];
            result["Гидроизоляция (75м2)"]["sum"] = Math.ceil(S / 70) + ' (рулон)';
            result["Гидроизоляция (75м2)"]["size"] = S.toFixed(2);

            result["Пароизоляция (75м2)"] = [];
            result["Пароизоляция (75м2)"]["sum"] = Math.ceil(S / 70) + ' (рулон)';
            result["Пароизоляция (75м2)"]["size"] = S.toFixed(2);

            result["Теплоизоляция в м3"] = [];
            result["Теплоизоляция в м3"]["sum"] = (S * 0.2).toFixed(2) + ' м3';
            result["Теплоизоляция в м3"]["size"] = S.toFixed(2);

            /*-------------------------------------------------------------*/

            result["Водосточная система"] = [];
            result["Водосточная система"]["separate"] = true;

            result["Желоб (3м.)"] = [];
            result["Желоб (3м.)"]["sum"] = Math.ceil(c * 2 / 3) + ' шт';
            result["Желоб (3м.)"]["size"] = (c * 2 / 3).toFixed(2);

            result["Держатель желоба"] = [];
            result["Держатель желоба"]["sum"] = Math.ceil(a * 3 / 0.6) + ' шт';
            result["Держатель желоба"]["size"] = (a * 3 / 0.6).toFixed(2);

            result["Соединитель желоба"] = [];
            result["Соединитель желоба"]["sum"] = Math.ceil(c * 2 / 3) - 1 + ' шт';
            result["Соединитель желоба"]["size"] = ' --- ';

            result["Заглушки желоба"] = [];
            result["Заглушки желоба"]["sum"] = '4 шт';
            result["Заглушки желоба"]["size"] = ' --- ';

            result["Воронка желоба"] = [];
            result["Воронка желоба"]["sum"] = '2 шт';
            result["Воронка желоба"]["size"] = ' --- ';

            result["Колено"] = [];
            result["Колено"]["sum"] = '4 шт';
            result["Колено"]["size"] = ' --- ';

            result["Сливное колено"] = [];
            result["Сливное колено"]["sum"] = ' 2 шт';
            result["Сливное колено"]["size"] = ' --- ';

            result["Труба (3м.)"] = [];
            result["Труба (3м.)"]["sum"] = Math.ceil(Math.ceil(d - 3 * 0.3 - 0.25) * 2 / 3) + ' шт';
            result["Труба (3м.)"]["size"] = ' --- ';

            result["Кровельные аксессуары"] = [];
            result["Кровельные аксессуары"]["separate"] = true;

            result["Саморезы кровельные"] = [];
            result["Саморезы кровельные"]["sum"] = Math.ceil(Math.ceil(S * 6) / 100) * 100 + ' шт';
            result["Саморезы кровельные"]["size"] = ' --- ';

            result["Снегозадержатель (3м.)"] = [];
            result["Снегозадержатель (3м.)"]["sum"] = Math.ceil(c * 2 / 3) + ' шт';
            result["Снегозадержатель (3м.)"]["size"] = (c * 2 / 3).toFixed(2);

            result["Ограждение кровли"] = [];
            result["Ограждение кровли"]["sum"] = Math.ceil(c * 2 / 1.86) + ' м';
            result["Ограждение кровли"]["size"] = (c * 2 / 1.86).toFixed(2);

            result["Переходной мост"] = [];
            result["Переходной мост"]["sum"] = '1 шт';
            result["Переходной мост"]["size"] = ' --- ';

            /*var lesnicaCrovl = Math.ceil(7/1.86);
             var lesnicaSten = Math.ceil(4.15/1.86);

             result["Лестница"] = [];
             result["Лестница"]["sum"] = lesnicaCrovl+lesnicaSten +' шт';
             result["Лестница"]["size"] = ' --- ';
             */
            result["Лестница"] = [];
            result["Лестница"]["sum"] = '1 шт';
            result["Лестница"]["size"] = ' --- ';

            /*result["Поручень лестницы"] = [];
             result["Поручень лестницы"]["sum"] = '2 шт';
             result["Поручень лестницы"]["size"] = ' --- ';

             result["Кронштейн на конек для лестницы"] = [];
             result["Кронштейн на конек для лестницы"]["sum"] = '2 шт';
             result["Кронштейн на конек для лестницы"]["size"] = ' --- ';

             result["Кронштейн к стене для лестницы"] = [];
             result["Кронштейн к стене для лестницы"]["sum"] = lesnicaSten*4+' шт';
             result["Кронштейн к стене для лестницы"]["size"] = ' --- ';

             result["Кронштейн на кровлю для лестницы"] = [];
             result["Кронштейн на кровлю для лестницы"]["sum"] = lesnicaCrovl*4+' шт';
             result["Кронштейн на кровлю для лестницы"]["size"] = ' --- ';

             result["Вентиль КТВ"] = [];
             result["Вентиль КТВ"]["sum"] = Math.ceil(S/50) + ' шт';
             result["Вентиль КТВ"]["size"] = S/50;
             */

            this.appendResult(result, 'sum');
        }

    },

    /* Вальмовая  */
    formulaTwo: function (object) {
        var fields = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
        var error = [];

        this.clearError();

        for (var k in fields) {
            if (object[fields[k]] == undefined || object[fields[k]] == '') {
                error.push(fields[k]);
            }
        }

        if (error.length > 0) {
            // Error handling
            this.clearResult();

            this.showError(error);
        } else {
            var a = Number((object['a'].split(",")).join("."));
            var b = Number((object['b'].split(",")).join("."));
            var c = Number((object['c'].split(",")).join("."));
            var d = Number((object['d'].split(",")).join("."));
            var e = Number((object['e'].split(",")).join("."));
            var f = Number((object['f'].split(",")).join("."));
            var g = Number((object['g'].split(",")).join("."));

            var result = [];

            var kon_sum = (b + (c * 4)).toFixed(2);

            var S = Math.ceil(Math.sqrt((((c * 2 + d) / 2) * ((c * 2 + d) / 2 - c) * ((c * 2 + d) / 2 - c) * ((c * 2 + d) / 2 - d))) * 2 + (b + e) * a);

            if (coverType === 'prof') {

                result["Профнастил (2м.)"] = [];
                result["Профнастил (2м.)"]["size"] = Math.ceil((S / prof) * 1.15) + ' шт';
            } else {

                result["Металлочерепица (2.25м.)"] = [];
                result["Металлочерепица (2.25м.)"]["size"] = Math.ceil((S / metal) * 1.15) + ' шт';
            }

            result["Общая площадь кровли"] = [];
            result["Общая площадь кровли"]["size"] = Math.ceil(S) + ' м2';


            result["Доборные элементы"] = [];
            result["Доборные элементы"]["separate"] = true;

            /* Формула "Конек и уплотнитель"*/
            result["Планка конька (2м.)"] = [];
            result["Планка конька (2м.)"]["sum"] = kon_sum;
            result["Планка конька (2м.)"]["size"] = Math.ceil(kon_sum / (2 - 0.05)) + ' шт';
            /*end*/

            result["Уплотнитель планки конька (2м.)"] = [];
            result["Уплотнитель планки конька (2м.)"]["sum"] = kon_sum;
            result["Уплотнитель планки конька (2м.)"]["size"] = Math.ceil(kon_sum / (2 - 0.05)) * 2 + ' шт';

            /* Формула "Карнизная" */
            var n = d * 2 + e * 2;

            result["Карнизная планка (2м.)"] = [];
            result["Карнизная планка (2м.)"]["sum"] = n.toFixed(2);
            result["Карнизная планка (2м.)"]["size"] = Math.ceil(n / (2 - 0.05)) + ' шт';
            /*end*/

            /* "Примыкание нижняя"  */
            var o = 0.4 * 4;

            result["Планка примыкания (нижняя) (2м.)"] = [];
            result["Планка примыкания (нижняя) (2м.)"]["sum"] = o;
            result["Планка примыкания (нижняя) (2м.)"]["size"] = Math.ceil(o / (2 - 0.05)) + ' шт';
            /*end*/

            /* "Примыкание верхняя" */
            var p = 0.4 * 4;

            result["Планка примыкания (верхняя) (2м.)"] = [];
            result["Планка примыкания (верхняя) (2м.)"]["sum"] = p;
            result["Планка примыкания (верхняя) (2м.)"]["size"] = Math.ceil(o / (2 - 0.05)) + ' шт';
            /*end*/

            result["Изоляционные материалы"] = [];
            result["Изоляционные материалы"]["separate"] = true;

            result["Гидроизоляция (75м2)"] = [];
            result["Гидроизоляция (75м2)"]["sum"] = S.toFixed(2);
            result["Гидроизоляция (75м2)"]["size"] = Math.ceil(S / 70) + '(рулона)';

            result["Пароизоляция (75м2)"] = [];
            result["Пароизоляция (75м2)"]["sum"] = S.toFixed(2);
            result["Пароизоляция (75м2)"]["size"] = Math.ceil(S / 70) + '(рулона)';

            result["Теплоизоляция в м3"] = [];
            result["Теплоизоляция в м3"]["sum"] = S.toFixed(2);
            result["Теплоизоляция в м3"]["size"] = (S * 0.2).toFixed(2) + ' м3';

            result["Водосточная система"] = [];
            result["Водосточная система"]["separate"] = true;

            result["Водосток Аквасистем"] = [];
            result["Водосток Аквасистем"]["sum"] = ' --- ';
            result["Водосток Аквасистем"]["size"] = (e * 2 + 9 * 2) + ' ПГм';

            var xolob = Math.ceil(Math.ceil(e * 2 + 9 * 2) / 3);

            result["Желоб (3м.)"] = [];
            result["Желоб (3м.)"]["sum"] = ' ---  ';
            result["Желоб (3м.)"]["size"] = xolob + ' шт';

            result["Держатель желоба"] = [];
            result["Держатель желоба"]["sum"] = ' --- ';
            result["Держатель желоба"]["size"] = xolob * 3 / 0.6 + ' шт';

            result["Соединитель желоба"] = [];
            result["Соединитель желоба"]["sum"] = ' --- ';
            result["Соединитель желоба"]["size"] = xolob + 4 + ' шт';

            result["Угол желоба наружный"] = [];
            result["Угол желоба наружный"]["sum"] = ' --- ';
            result["Угол желоба наружный"]["size"] = '4 шт';

            result["Воронка желоба"] = [];
            result["Воронка желоба"]["sum"] = ' --- ';
            result["Воронка желоба"]["size"] = '6 шт';

            result["Колено"] = [];
            result["Колено"]["sum"] = ' --- ';
            result["Колено"]["size"] = 6 * 2 + ' шт';

            result["Сливное колено"] = [];
            result["Сливное колено"]["sum"] = ' --- ';
            result["Сливное колено"]["size"] = '6 шт';

            result["Труба 3м"] = [];
            result["Труба 3м"]["sum"] = ' --- ';
            result["Труба 3м"]["size"] = Math.ceil(Math.ceil(f - 3 * 0.3 - 0.25) * 2 / 3) + ' шт';

            result["Кровельные аксессуары"] = [];
            result["Кровельные аксессуары"]["separate"] = true;

            result["Саморезы кровельные"] = [];
            result["Саморезы кровельные"]["sum"] = ' --- ';
            result["Саморезы кровельные"]["size"] = Math.ceil(Math.ceil(S * 6) / 100) * 100 + ' шт';

            result["Снегозадержатель (3м.)"] = [];
            result["Снегозадержатель (3м.)"]["sum"] = ' --- ';
            result["Снегозадержатель (3м.)"]["size"] = xolob + ' шт';

            result["Ограждение кровли"] = [];
            result["Ограждение кровли"]["sum"] = ' --- ';
            result["Ограждение кровли"]["size"] = Math.ceil((e * 2 + 9 * 2) / 1.86) + ' м';

            result["Переходной мост"] = [];
            result["Переходной мост"]["sum"] = ' --- ';
            result["Переходной мост"]["size"] = '1 шт';

            /*var lesnicaCrovl = Math.ceil(8/1.86);
             var lesnicaSten = Math.ceil(4.15/1.86);

             result["Лестница"] = [];
             result["Лестница"]["sum"] = ' --- ';
             result["Лестница"]["size"] = lesnicaCrovl+lesnicaSten +' шт';
             */
            result["Лестница"] = [];
            result["Лестница"]["sum"] = ' --- ';
            result["Лестница"]["size"] = '1 шт';
            /*
             result["Поручень лестницы"] = [];
             result["Поручень лестницы"]["sum"] = ' --- ';
             result["Поручень лестницы"]["size"] = '2 шт';

             result["Кронштейн на конек для лестницы"] = [];
             result["Кронштейн на конек для лестницы"]["sum"] = ' --- ';
             result["Кронштейн на конек для лестницы"]["size"] = '2 шт';

             result["Кронштейн к стене для лестницы"] = [];
             result["Кронштейн к стене для лестницы"]["sum"] = ' --- ';
             result["Кронштейн к стене для лестницы"]["size"] = lesnicaSten*4+' шт';

             result["Кронштейн на кровлю для лестницы"] = [];
             result["Кронштейн на кровлю для лестницы"]["sum"] = ' --- ';
             result["Кронштейн на кровлю для лестницы"]["size"] = lesnicaCrovl*4+' шт';

             result["Вентиль КТВ"] = [];
             result["Вентиль КТВ"]["sum"] = S/50;
             result["Вентиль КТВ"]["size"] = Math.ceil(S/50) + ' шт';
             */

            this.appendResult(result, 'size');
        }
    },

    /* Мансардная */
    formulaThree: function (object) {
        var fields = ['a', 'b', 'c', 'd', 'e'];
        var error = [];

        this.clearError();

        for (var k in fields) {
            if (object[fields[k]] == undefined || object[fields[k]] == '') {
                error.push(fields[k]);
            }
        }

        if (error.length > 0) {
            // Error handling
            this.clearResult();

            this.showError(error);
        } else {
            var a = Number((object['a'].split(",")).join("."));
            var b = Number((object['b'].split(",")).join("."));
            var c = Number((object['c'].split(",")).join("."));
            var d = Number((object['d'].split(",")).join("."));
            var e = Number((object['e'].split(",")).join("."));

            var result = [];

            var S = (a * 2 + b * 2) * c;

            if (coverType === 'prof') {
                result["Профнастил (2м.)"] = [];
                result["Профнастил (2м.)"]["sum"] = Math.ceil((S / prof) * 1.15) + ' шт';
            } else {
                result["Металлочерепица (2.25м)"] = [];
                result["Металлочерепица (2.25м)"]["sum"] = Math.ceil((S / metal) * 1.15) + ' шт';
            }

            result["Общая площадь кровли"] = [];
            result["Общая площадь кровли"]["sum"] = Math.ceil(S) + ' м2';


            result["Доборные элементы"] = [];
            result["Доборные элементы"]["separate"] = true;

            /* Формула "Конек и уплотнитель"*/
            result["Планка конька (2м.)"] = [];
            result["Планка конька (2м.)"]["sum"] = Math.ceil(c / (2 - 0.05)) + ' шт';
            result["Планка конька (2м.)"]["size"] = ' --- ';
            /*end*/

            result["Уплотнитель планки конька (2м.)"] = [];
            result["Уплотнитель планки конька (2м.)"]["sum"] = Math.ceil(c / (2 - 0.05)) * 2 + ' шт';
            result["Уплотнитель планки конька (2м.)"]["size"] = ' --- ';


            /* Формула расчёта "Ветровая (торцевая) планка" */
            var L = (a * 4) + (b * 4);

            result["Ветровая (торцевая) планка (2м.)"] = [];
            result["Ветровая (торцевая) планка (2м.)"]["sum"] = Math.ceil(L / (2 - 0.05)) + ' шт';
            result["Ветровая (торцевая) планка (2м.)"]["size"] = L;
            /*end*/

            /* Формула "Карнизная" */
            var n = c * 2;

            result["Карнизная планка (2м.)"] = [];
            result["Карнизная планка (2м.)"]["sum"] = Math.ceil(n / (2 - 0.05)) + ' шт';
            result["Карнизная планка (2м.)"]["size"] = n.toFixed(2);

            /*end*/

            /* "Примыкание нижняя"  */
            var o = 0.4 * 4;

            result["Планка примыкания (нижняя) (2м.)"] = [];
            result["Планка примыкания (нижняя) (2м.)"]["sum"] = Math.ceil(o / (2 - 0.05)) + ' шт';

            result["Планка примыкания (нижняя) (2м.)"]["size"] = o;
            /*end*/

            /* "Примыкание верхняя" */
            var p = 0.4 * 4;

            result["Планка примыкания (верхняя) (2м.)"] = [];
            result["Планка примыкания (верхняя) (2м.)"]["sum"] = Math.ceil(o / (2 - 0.05)) + ' шт';

            result["Планка примыкания (верхняя) (2м.)"]["size"] = p;
            /*end*/

            result["Изоляционные материалы"] = [];
            result["Изоляционные материалы"]["separate"] = true;

            result["Гидроизоляция (75м2)"] = [];
            result["Гидроизоляция (75м2)"]["sum"] = Math.ceil(S / 70) + ' (рулон)';

            result["Гидроизоляция (75м2)"]["size"] = S.toFixed(2);

            result["Пароизоляция (75м2)"] = [];
            result["Пароизоляция (75м2)"]["sum"] = Math.ceil(S / 70) + ' (рулон)';
            result["Пароизоляция (75м2)"]["size"] = S.toFixed(2);

            result["Теплоизоляция в м3"] = [];
            result["Теплоизоляция в м3"]["sum"] = (S * 0.2).toFixed(2) + ' м3';
            result["Теплоизоляция в м3"]["size"] = S.toFixed(2);

            result["Водосточная система"] = [];
            result["Водосточная система"]["separate"] = true;

            result["Желоб (3м.)"] = [];
            result["Желоб (3м.)"]["sum"] = Math.ceil(c * 2 / 3) + ' шт';
            result["Желоб (3м.)"]["size"] = (c * 2 / 3).toFixed(2);

            result["Держатель желоба"] = [];
            result["Держатель желоба"]["sum"] = Math.ceil(Math.ceil(c * 2 / 3) * 3 / 0.6) + ' шт';
            result["Держатель желоба"]["size"] = (Math.ceil(c * 2 / 3) * 3 / 0.6).toFixed(2);

            result["Соединитель желоба"] = [];
            result["Соединитель желоба"]["sum"] = Math.ceil(c * 2 / 3) - 1 + ' шт';
            result["Соединитель желоба"]["size"] = ' --- ';

            result["Заглушки желоба"] = [];
            result["Заглушки желоба"]["sum"] = '4 шт';
            result["Заглушки желоба"]["size"] = ' --- ';

            result["Воронка желоба"] = [];
            result["Воронка желоба"]["sum"] = '4 шт';
            result["Воронка желоба"]["size"] = ' --- ';

            result["Колено"] = [];
            result["Колено"]["sum"] = '8 шт';
            result["Колено"]["size"] = ' --- ';

            result["Сливное колено"] = [];
            result["Сливное колено"]["sum"] = ' 4 шт';
            result["Сливное колено"]["size"] = ' --- ';

            result["Труба 3м"] = [];
            result["Труба 3м"]["sum"] = Math.ceil(Math.ceil(d - 3 * 0.3 - 0.25) * 2 / 3) + ' м';
            result["Труба 3м"]["size"] = ' --- ';

            result["Кровельные аксессуары"] = [];
            result["Кровельные аксессуары"]["separate"] = true;

            result["Саморезы кровельные"] = [];
            result["Саморезы кровельные"]["sum"] = Math.ceil(Math.ceil(S * 6) / 100) * 100 + ' шт';
            result["Саморезы кровельные"]["size"] = ' --- ';

            result["Снегозадержатель (3м.)"] = [];
            result["Снегозадержатель (3м.)"]["sum"] = Math.ceil(c * 2 / 3) + ' шт';
            result["Снегозадержатель (3м.)"]["size"] = (c * 2 / 3).toFixed(2);

            result["Ограждение кровли"] = [];
            result["Ограждение кровли"]["sum"] = Math.floor(c * 2 / 1.86) + ' м';

            result["Ограждение кровли"]["size"] = (c * 2 / 1.86).toFixed(2);

            result["Переходной мост"] = [];
            result["Переходной мост"]["sum"] = '1 шт';
            result["Переходной мост"]["size"] = ' --- ';

            /*var lesnicaCrovl = Math.ceil((7+5.5)/1.86);
             var lesnicaSten = Math.floor(4.15/1.86);

             result["Лестница"] = [];
             result["Лестница"]["sum"] = lesnicaCrovl+lesnicaSten +' шт';
             result["Лестница"]["size"] = ' --- ';
             */
            result["Лестница"] = [];
            result["Лестница"]["sum"] = '1 шт';
            result["Лестница"]["size"] = ' --- ';
            /*
             result["Поручень лестницы"] = [];
             result["Поручень лестницы"]["sum"] = '2 шт';
             result["Поручень лестницы"]["size"] = ' --- ';

             result["Кронштейн на конек для лестницы"] = [];
             result["Кронштейн на конек для лестницы"]["sum"] = '2 шт';
             result["Кронштейн на конек для лестницы"]["size"] = ' --- ';

             result["Кронштейн к стене для лестницы"] = [];
             result["Кронштейн к стене для лестницы"]["sum"] = lesnicaSten*4+' шт';
             result["Кронштейн к стене для лестницы"]["size"] = ' --- ';

             result["Кронштейн на кровлю для лестницы"] = [];
             result["Кронштейн на кровлю для лестницы"]["sum"] = lesnicaCrovl*4+' шт';
             result["Кронштейн на кровлю для лестницы"]["size"] = ' --- ';

             result["Вентиль КТВ"] = [];
             result["Вентиль КТВ"]["sum"] = Math.ceil(S/50) + ' шт';
             result["Вентиль КТВ"]["size"] = S/50;
             */

            this.appendResult(result, 'sum');
        }
    }


};

$(document).ready(function () {
    wmCalculator.build('1');
    wmCalculator.selectType();

    $('.calc__item input[type=radio][name=buttom]').click(function (event) {
        wmCalculator.build($(event.target).val());
    });

    $('.calc__item input[name=cover]').click(function (event) {
        wmCalculator.selectType($(event.target).val());
    });

    var lock = 0;
    $(document).on('keyup', '.calc__field .calc__field-input', inputGroup, function (event) {
        var attrName = $(event.target).attr('name');
        var nameValue = $(event.target).val();

        objectVal[attrName] = nameValue;
    });

    $('.sum-calc__button').on('click', function () {
        wmCalculator.mathFormul(mainFormId, objectVal);
    });
});